import styled from '@emotion/styled';
import { Col, Row } from 'antd';

export const SubMenuItem = styled(Row)`
  color: ${props => props.theme.color.white};
  cursor: pointer;
  margin-bottom: ${props => props.theme.spacing.md};
  &:first-of-type {
    margin-top: ${props => props.theme.spacing.xxxl};
  }
`;

export const SubMenuItemContainer = styled(Col)`
  border-radius: 0 16px 16px 0;
  transition: ${props => (props.isActive ? 'background .5s cubic-bezier(0,0,0.58,1)' : 'none')};
  background-color: ${props => (props.isActive ? props.theme.color.complementary : props.theme.color.primary)};
  color: ${props => (props.isActive ? props.theme.color.primary : props.theme.color.white)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 48px;
  width: 100%;
  text-align: center;
`;

export const SubMenuItemIcon = styled.img`
  display: block;
  margin: 0 auto;
  width: 24px;
  height: 24px;
`;
